import { render, staticRenderFns } from "./ModalOmploop.vue?vue&type=template&id=2c45180e"
import script from "./ModalOmploop.vue?vue&type=script&lang=js"
export * from "./ModalOmploop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports